import GiftPointsIcon from './gift-points'
import TicketSaleIcon from './ticket-sale'
import MyPurchasesIcon from './my-purchases'
import MoveflexClubIcon from './moveflex-club'
import PointsPurchaseIcon from './points-purchase'
import ExtractOfPointsIcon from './extract-of-points'
import ClientInformationIcon from './client-information'
import InviteYourFriendsIcon from './invite-your-friends'
import PointsSolicitationIcon from './points-solicitation'
import ExchangeYourPointsIcon from './exchange-your-points'
import MuvicardIcon from './muvicard-icon'

export {
	GiftPointsIcon,
	TicketSaleIcon,
	MyPurchasesIcon,
	MoveflexClubIcon,
	PointsPurchaseIcon,
	ExtractOfPointsIcon,
	ClientInformationIcon,
	InviteYourFriendsIcon,
	ExchangeYourPointsIcon,
	PointsSolicitationIcon,
	MuvicardIcon
}
